import { Helmet } from "react-helmet-async";
import TabsMAIQ from "app/components/TabsMAIQ";
import RolesTab from "./components/role/RolesTab";
import ScopesTab from "./components/scope/ScopesTab";
import ResourcesTab from "./components/resource/ResourcesTab";
import { PageContainer, PageHeader } from "app/components/StyledComponents";
import { BreadcrumbsComponent } from "app/components/BreadcrumbsComponent";
import { logger } from 'app/utils/logger';
import { RoleProvider } from "app/context/RoleContext";
import { ScopeProvider } from "app/context/ScopeContext";
import { ResourceProvider } from "app/context/ResourceContext";

const RoleManagementPage = () => {
  const tabsData = [
    { label: "ROLES", content: <RolesTab /> },
    { label: "SCOPES", content: <ScopesTab /> },
    { label: "RESOURCES", content: <ResourcesTab /> },
  ];

  const breadcrumbsList = [
    { label: "Role Management", isActive: true }
  ];

  logger.log('This will show in dev/staging/test, but not in production');

  return (
    <RoleProvider>
      <ScopeProvider>
        <ResourceProvider>
          <Helmet>
            <title>Role Management</title>
            <meta name="description" content="Manage Roles, Scopes, and Resources Information" />
          </Helmet>
          <PageContainer sx={{ pb: 0 }}>
            <BreadcrumbsComponent breadcrumbsList={breadcrumbsList} />
            <PageHeader>Role Management</PageHeader>
            <TabsMAIQ tabs={tabsData} />
          </PageContainer>
        </ResourceProvider>
      </ScopeProvider>
    </RoleProvider>
  );
};

export default RoleManagementPage; 